<div class="a-titulo">Reporte Cliente Nave</div>
<form [formGroup]="group">
    <div class="a-w1-row">
        <p-floatLabel class=" a-w6" variant="on">
            <p-datepicker formControlName="desde" appendTo="body" showIcon="true" iconDisplay="input"
                dateFormat="dd/mm/yy" styleClass="w-full">
            </p-datepicker>
            <label for="on_label">Fecha Desde</label>
        </p-floatLabel>
        <p-floatLabel class=" a-w6" variant="on">
            <p-datepicker formControlName="hasta" appendTo="body" showIcon="true" iconDisplay="input"
                dateFormat="dd/mm/yy" styleClass="w-full">
            </p-datepicker>
            <label for="on_label">Fecha Hasta</label>
        </p-floatLabel>
        <p-floatLabel class=" a-w4" variant="on">
            <p-select [options]="Naves" placeholder="‎ " formControlName="nave" appendTo="body" styleClass="w-full"
                filter="true" virtualScroll="true" showClear="true" virtualScrollItemSize="10">
            </p-select>
            <label for="nave">Nave Viaje</label>
        </p-floatLabel>

        <p-button icon="pi pi-search" label="Buscar" variant="outlined" (onClick)="search()"></p-button>
        <p-button icon="pi pi-download" label="Exportar" variant="outlined" (onClick)="export()"></p-button>
    </div>
</form>
<app-datatable [metadataTable]="metadatatable" [dataTable]="datatable"></app-datatable>
<div class="a-footer"></div>